var emailFormat =
  /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
var panFormat = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;

var gstFormat =
  /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){2}?$/;
var specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
var MobileRegrex = /^([1-9]){1}([0-9]){9}/;
var IFSCREGREX = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;
var SPACECHECK = /^[a-zA-Z][\sa-zA-Z0-9]*/;

const approveCustomValidation = (data) => {
    console.log(data);
    if (
      data.processingFeeAtDisbursment === "" ||
      data.processingFeeAtDisbursment === null
    ) {
      return {
        status: false,
        msg: "Please enter Processing Fee At Disbursment",
        field: "processingFeeAtDisbursment",
      };
    }
    if (data.processingFeeType === "" || data.processingFeeType === null) {
      return {
        status: false,
        msg: "Please enter Processing Fee Type",
        field: "processingFeeType",
      };
    }
    if (data.processingFee === "" || data.processingFee === null) {
      return {
        status: false,
        msg: "Please enter Processing Fee",
        field: "processingFee",
      };
    }
    if (data.typeOfInterestRate === "" || data.typeOfInterestRate === null) {
      return {
        status: false,
        msg: "Please enter Type Of Interest Rate",
        field: "typeOfInterestRate",
      };
    }
    if (data.rateOfInterest === "" || data.rateOfInterest === null) {
      return {
        status: false,
        msg: "Please enter Rate Of Interest",
        field: "rateOfInterest",
      };
    }
    if (data.penaltyFeeType === "" || data.penaltyFeeType === null) {
      return {
        status: false,
        msg: "Please enter Penalty Fee Type",
        field: "penaltyFeeType",
      };
    }
    if (data.penaltyFee === "" || data.penaltyFee === null) {
      return {
        status: false,
        msg: "Please enter Penalty Fee",
        field: "penaltyFee",
      };
    }
    return {
      status: true,
      msg: "",
      field: "",
    };
  };

const CommunityLeadsPersonalValidation = (userData) => {
    console.log(userData.name, typeof userData.name);
    if (
      userData.name === "" ||
      userData.name === null ||
      userData.name === undefined
    ) {
      return {
        status: false,
        msg: "Please enter Name",
        field: "name",
      };
    } else if (specialChar.test(userData.name)) {
      return {
        status: false,
        msg: "Please enter valid Name",
        field: "name",
      };
    } else if (!SPACECHECK.test(userData.name)) {
      return {
        status: false,
        msg: "enter valid name",
        field: "name",
      };
    }
    if (userData.emailId === "" || userData.emailId === null) {
      return {
        status: false,
        msg: "Please enter Email Id",
        field: "emailId",
      };
    } else if (!emailFormat.test(userData.emailId)) {
      return {
        status: false,
        msg: "Please enter correct Email Id",
        field: "emailId",
      };
    }
    if (userData.emailId.length > 100) {
      return {
        status: false,
        msg: "Please enter valid Email Id",
        field: "emailId",
      };
    }
    if (userData.mobileNo === "" || userData.mobileNo === null) {
      return {
        status: false,
        msg: "Please enter Mobile Number",
        field: "mobileNo",
      };
    } else if (!MobileRegrex.test(userData.mobileNo)) {
      return {
        status: false,
        msg: "Please enter valid 10 digit Mobile Number",
        field: "mobileNo",
      };
    }
    // if (userData.dob && moment(new Date()).diff(moment(userData.dob), 'year') <= 18) {
    //     return {
    //         status: false,
    //         msg: 'Age should be greater then 18 years',
    //         field: 'dob'
    //     }
    // }
    // if (userData.dob === 'Invalid date') {
    //     return {
    //         status: false,
    //         msg: 'Please enter valid Date of Birth',
    //         field: 'dob'
    //     }
    // }
    if (
      userData.pan !== undefined &&
      userData.pam !== null &&
      userData.pan !== "" &&
      !panFormat.test(userData.panNo)
    ) {
      return {
        status: false,
        msg: "Please enter correct Pan Number",
        field: "panNo",
      };
    }
    // if (userData.pan !== undefined && userData.pam!==null && userData.pan!=='' &&& userData.nameOnPan === '' || userData.nameOnPan === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Name on Pan',
    //         field: 'nameOnPan'
    //     }
    // }
  
    // if (userData.aadharNo === '' || userData.aadharNo === null || userData.aadharNo === undefined) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Aadhar No',
    //         field: 'aadharNo'
    //     }
    // }
    if (
      userData.aadharNo &&
      userData.aadharNo &&
      userData.aadharNo.toString().length !== 12
    ) {
      return {
        status: false,
        msg: "Please enter 12 digit Aadhaar Number",
        field: "aadharNo",
      };
    }
    if (userData.aadharNo && userData.aadharNo === "000000000000") {
      return {
        status: false,
        msg: "enter valid Aadhaar Number",
        field: "aadharNo",
      };
    }
    // if (userData.nameOnAadhaar === '' || userData.nameOnAadhaar === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Name on Aadhar No',
    //         field: 'nameOnAadhaar'
    //     }
    // }
  
    if (
      userData.loanSegment === "" ||
      userData.loanSegment === null ||
      userData.loanSegment === undefined
    ) {
      return {
        status: false,
        msg: "Please enter Loan Segment",
        field: "loanSegment",
      };
    }
    if (
      userData.loanType === "" ||
      userData.loanType === null ||
      userData.loanType === undefined
    ) {
      return {
        status: false,
        msg: "Please enter Loan Type",
        field: "loanType",
      };
    }
    if (userData.loanType === "other") {
      if (
        userData.enterloanType === "" ||
        userData.enterloanType === null ||
        userData.enterloanType === undefined
      ) {
        return {
          status: false,
          msg: "Please enter Loan Type",
          field: "enterloanType",
        };
      }
    }
    if (
      userData.borrowingType === "" ||
      userData.borrowingType === null ||
      userData.borrowingType === undefined
    ) {
      return {
        status: false,
        msg: "Please enter Borrowing Type",
        field: "borrowingType",
      };
    }
    if (
      userData.sourceOfIncome === "" ||
      userData.sourceOfIncome === null ||
      userData.sourceOfIncome === undefined
    ) {
      return {
        status: false,
        msg: "Please Select source Of Income",
        field: "sourceOfIncome",
      };
    }
    return {
      status: true,
      msg: "",
      field: "",
    };
  };


const CommunityLeadsBusinessValidation = (userData) => {
    // if (userData.loanFor === '' || userData.loanFor === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Loan For',
    //         field: 'loanFor'
    //     }
    // }
    // if (userData.designation === '' || userData.designation === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Designation',
    //         field: 'designation'
    //     }
    // } else
    if (userData.designation && !SPACECHECK.test(userData.designation)) {
      return {
        status: false,
        msg: "enter valid designation",
        field: "designation",
      };
    }
    if (userData.designation && specialChar.test(userData.designation)) {
      return {
        status: false,
        msg: "enter valid designation",
        field: "designation",
      };
    }
    // if (userData.typeOfBusiness === '' || userData.typeOfBusiness === null) {
    //     return {
    //         status: false,
    //         msg: 'Please select Type of Business',
    //         field: 'typeOfBusiness'
    //     }
    // }
    if (
      userData.typeOfConsititution === "" ||
      userData.typeOfConsititution === null
    ) {
      return {
        status: false,
        msg: "Please enter Type Of Consititution",
        field: "typeOfConsititution",
      };
    }
    // if (userData.businessDesc === '' || userData.businessDesc === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Business Description',
    //         field: 'businessDesc'
    //     }
    // }
    if (userData.businessDesc && !SPACECHECK.test(userData.businessDesc)) {
      return {
        status: false,
        msg: "enter valid business description",
        field: "businessDesc",
      };
    }
    if (userData.businessDesc && userData.businessDesc.length > 200) {
      return {
        status: false,
        msg: "only 200 words allowed",
        field: "businessDesc",
      };
    }
    // if (userData.quaterlyTurnover === '' || userData.quaterlyTurnover === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Quaterly Turnover',
    //         field: 'quaterlyTurnover'
    //     }
    // }
    // if (userData.lastYearTurnover === '' || userData.lastYearTurnover === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Last Year Turnover',
    //         field: 'lastYearTurnover'
    //     }
    // }
    // if (userData.lastYearTurnover < userData.quaterlyTurnover) {
    //     return {
    //         status: false,
    //         msg: 'Last Year Turnover should not be less than quaterly Turnover',
    //         field: 'lastYearTurnover'
    //     }
    // }
    // if (moment(userData.dateOfIncorporation).format('DD-MM-YYYY') === moment(new Date()).format('DD-MM-YYYY')) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Date Of Incorporation',
    //         field: 'dateOfIncorporation'
    //     }
    // }
    // if (userData.gstNo !== '' && userData.gstNo !== null) {
    //     if (!gstFormat.test(userData.gstNo)) {
    //         return {
    //             status: false,
    //             msg: 'Please enter correct GST Number',
    //             field: 'gstNo'
    //         }
    //     }
    // }
    // if (userData.tradeLicenseNoOrMSME === '' || userData.tradeLicenseNoOrMSME === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Trade License No Or MSME',
    //         field: 'tradeLicenseNoOrMSME'
    //     }
    // }
    // if (userData.typeOfConsititution === 'privatelimited' || userData.typeOfConsititution === 'llp') {
    //     if (userData.cinLlpin === '' || userData.cinLlpin === null) {
    //         return {
    //             status: false,
    //             msg: 'Please enter Cin Llp In',
    //             field: 'cinLlpin'
    //         }
    //     }
    // }
    if (
      (userData.typeOfConsititution &&
        userData.typeOfConsititution === "privatelimited") ||
      userData.typeOfConsititution === "llp" ||
      userData.typeOfConsititution === "partnership"
    ) {
      // if (userData.orgPanNo === '' || userData.orgPanNo === null) {
      //     return {
      //         status: false,
      //         msg: 'Please enter Org PAN No',
      //         field: 'orgPanNo'
      //     }
      // } else
      if (userData.orgPanNo && !panFormat.test(userData.orgPanNo)) {
        return {
          status: false,
          msg: "Please enter valid PAN Number",
          field: "orgPanNo",
        };
      }
    }
  
    return {
      status: true,
      msg: "",
      field: "",
    };
  };

const AddressValidation = (userData) => {
    // console.log(userData.address.charAt(0), 'userdata')
    // if (userData.address === '' || userData.address === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Address',
    //         field: 'address'
    //     }
    // } else
    if (userData.address && userData.address.charAt(0) === " ") {
      return {
        status: false,
        msg: "enter valid address",
        field: "address",
      };
    }
    if (userData.pincode) {
      if (userData.state === "" || userData.state === null) {
        return {
          status: false,
          msg: "Please enter State",
          field: "state",
        };
      }
      if (userData.city === "" || userData.city === null) {
        return {
          status: false,
          msg: "Please enter City",
          field: "city",
        };
      }
    }
    // if (userData.pincode === '' || userData.pincode === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Pincode',
    //         field: 'pincode'
    //     }
    // }
    // if (userData.addressPerm === '' || userData.addressPerm === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Address',
    //         field: 'addressPerm'
    //     }
    // } else
    if (userData.address && userData.address.charAt(0) === " ") {
      return {
        status: false,
        msg: "enter valid address",
        field: "addressPerm",
      };
    }
    if (userData.pincodePerm) {
      if (userData.statePerm === "" || userData.statePerm === null) {
        return {
          status: false,
          msg: "Please enter State",
          field: "statePerm",
        };
      }
      if (userData.cityPerm === "" || userData.cityPerm === null) {
        return {
          status: false,
          msg: "Please enter City",
          field: "cityPerm",
        };
      }
    }
    // if (userData.pincodePerm === '' || userData.pincodePerm === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Pincode',
    //         field: 'pincodePerm'
    //     }
    // }
    if (
      userData.gstNo !== null &&
      userData.gstNo !== undefined &&
      userData.gstNo !== ""
    ) {
      if (userData.addressComm === "" || userData.addressComm === null) {
        return {
          status: false,
          msg: "Please enter Address",
          field: "addressComm",
        };
      } else if (!SPACECHECK.test(userData.addressComm)) {
        return {
          status: false,
          msg: "enter valid address",
          field: "addressComm",
        };
      }
      if (userData.stateComm === "" || userData.stateComm === null) {
        return {
          status: false,
          msg: "Please enter State",
          field: "stateComm",
        };
      }
      if (userData.cityComm === "" || userData.cityComm === null) {
        return {
          status: false,
          msg: "Please enter City",
          field: "cityComm",
        };
      }
      if (userData.pincodeComm === "" || userData.pincodeComm === null) {
        return {
          status: false,
          msg: "Please enter Pincode",
          field: "pincodeComm",
        };
      }
    }
    if (userData.sourceOfIncome === "salary") {
      // if (userData.addressOrg === '' || userData.addressOrg === null) {
      //     return {
      //         status: false,
      //         msg: 'Please enter Address',
      //         field: 'addressOrg'
      //     }
      // } else
      if (userData.addressOrg && !SPACECHECK.test(userData.addressOrg)) {
        return {
          status: false,
          msg: "enter valid address",
          field: "addressOrg",
        };
      }
      // if (userData.stateOrg === '' || userData.stateOrg === null) {
      //     return {
      //         status: false,
      //         msg: 'Please enter State',
      //         field: 'stateOrg'
      //     }
      // }
      // if (userData.cityOrg === '' || userData.cityOrg === null) {
      //     return {
      //         status: false,
      //         msg: 'Please enter City',
      //         field: 'cityOrg'
      //     }
      // }
      // if (userData.pincodeOrg === '' || userData.pincodeOrg === null) {
      //     return {
      //         status: false,
      //         msg: 'Please enter Pincode',
      //         field: 'pincodeOrg'
      //     }
      // }
    }
  
    return {
      status: true,
      msg: "",
      field: "",
    };
  };

const CommunityLeadLoanValidation = (userData) => {
    console.log(userData);
    if (
      userData.loanAmount === "" ||
      userData.loanAmount === null ||
      userData.loanAmount == 0
    ) {
      return {
        status: false,
        msg: "Please enter Loan Amount",
        field: "loanAmount",
      };
    }
    // if (userData.tenurePeriod === '' || userData.tenurePeriod === null || userData.tenurePeriod == 0) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Tenure',
    //         field: 'tenurePeriod'
    //     }
    // }
    // if (userData.loanType === '' || userData.loanType === null) {
    //     return {
    //         status: false,
    //         msg: 'Please select Nature Of Loan',
    //         field: 'loanType'
    //     }
    // }
    // if (userData.loanReason === '' || userData.loanReason === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Reason Of Loan',
    //         field: 'loanReason'
    //     }
    // } else if (!SPACECHECK.test(userData.loanReason)) {
    //     return {
    //         status: false,
    //         msg: 'enter valid loan reason',
    //         field: 'loanReason'
    //     }
    // } else if (specialChar.test(userData.loanReason)) {
    //     return {
    //         status: false,
    //         msg: 'enter valid loan reason',
    //         field: 'loanReason'
    //     }
    // }
    return {
      status: true,
      msg: "",
      field: "",
    };
  };


const CommunityLeadsSalariedValidation = (userData) => {
    // if (userData.nameOfOrganisation === '' || userData.nameOfOrganisation === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Name Of Organisation',
    //         field: 'nameOfOrganisation'
    //     }
    // } else if (!SPACECHECK.test(userData.nameOfOrganisation)) {
    //     return {
    //         status: false,
    //         msg: 'enter valid name',
    //         field: 'nameOfOrganisation'
    //     }
    // } else if (specialChar.test(userData.nameOfOrganisation)) {
    //     return {
    //         status: false,
    //         msg: 'enter valid name',
    //         field: 'nameOfOrganisation'
    //     }
    // }
    // if (userData.monthlySalary === '' || userData.monthlySalary === null) {
    //     return {
    //         status: false,
    //         msg: 'Please select Monthly Salary',
    //         field: 'monthlySalary'
    //     }
    // }
    // if (userData.salaryDay === '' || userData.salaryDay === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Salary Day',
    //         field: 'salaryDay'
    //     }
    // } else if (Number(userData.salaryDay) === 0 || Number(userData.salaryDay > 31)) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Valid Salary Day',
    //         field: 'salaryDay'
    //     }
    // }
    // if (moment(userData.joiningDate).format('DD-MM-YYYY') === moment(new Date()).format('DD-MM-YYYY')) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Joining Date',
    //         field: 'joiningDate'
    //     }
    // }
    // if (userData.totalExperience === '' || userData.totalExperience === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Total Experience',
    //         field: 'totalExperience'
    //     }
    // }
    // if (userData.designation === '' || userData.designation === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Designation',
    //         field: 'designation'
    //     }
    // } else if (!SPACECHECK.test(userData.designation)) {
    //     return {
    //         status: false,
    //         msg: 'enter valid name',
    //         field: 'designation'
    //     }
    // } else if (specialChar.test(userData.designation)) {
    //     return {
    //         status: false,
    //         msg: 'enter valid designation',
    //         field: 'designation'
    //     }
    // }
    // if (userData.education === '' || userData.education === null) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Education',
    //         field: 'education'
    //     }
    // }
    return {
      status: true,
      msg: "",
      field: "",
    };
  };

const CommunityPersonalValidation = (userData) => {
    if (userData.name === "" || userData.name === null) {
      return {
        status: false,
        msg: "Please enter Name",
        field: "name",
      };
    }
    if (userData.email === "" || userData.email === null) {
      return {
        status: false,
        msg: "Please enter Email Id",
        field: "email",
      };
    } else if (!emailFormat.test(userData.email)) {
      return {
        status: false,
        msg: "Please enter correct Email Id",
        field: "email",
      };
    }
    if (userData.email.length > 100) {
      return {
        status: false,
        msg: "Please enter valid Email Id",
        field: "email",
      };
    }
    if (userData.mobileNumber === "" || userData.mobileNumber === null) {
      return {
        status: false,
        msg: "Please enter Mobile Number",
        field: "mobileNumber",
      };
    } else if (userData.mobileNumber.toString().length !== 10) {
      return {
        status: false,
        msg: "Please enter 10 digit Mobile Number",
        field: "mobileNumber",
      };
    }
    if (userData.aadhaarNo === "" || userData.aadhaarNo === null) {
      return {
        status: false,
        msg: "Please enter Aadhar Number",
        field: "aadhaarNo",
      };
    }
    console.log("userData.aadhaarNo", typeof userData.aadhaarNo);
    if (userData.aadhaarNo === "000000000000") {
      return {
        status: false,
        msg: "Please enter Aadhar Number",
        field: "aadhaarNo",
      };
    }
    if (userData.password === "" || userData.password === null) {
      return {
        status: false,
        msg: "Please enter Password",
        field: "password",
      };
    }
    return {
      status: true,
      msg: "",
      field: "",
    };
  };

 const CommunityPersonalValidationNew = (userData) => {
    if (
      userData.whoYouAre === "" ||
      userData.whoYouAre === null ||
      userData.whoYouAre === undefined
    ) {
      return {
        status: false,
        msg: "Select Who you are",
        field: "whoYouAre",
      };
  
      // if (userData.whoYouAre === 'CA' || userData.whoYouAre === 'CS' || userData.whoYouAre === 'CWA') {
      // if (userData.memberShipNumber === '' || userData.memberShipNumber === null || userData.memberShipNumber === undefined) {
      //     return {
      //         status: false,
      //         msg: 'Please enter Membership Number',
      //         field: 'memberShipNumber'
      //     }
      // }
      // }
      // if (userData.whoYouAre === 'OTHERS' || userData.whoYouAre === 'DSA') {
      //     if (userData.specify === '' || userData.specify === null || userData.specify === undefined) {
      //         return {
      //             status: false,
      //             msg: 'Please  Specify',
      //             field: 'specify'
      //         }
      //     }
      // }
    }
    if (
      userData.name === "" ||
      userData.name === null ||
      userData.name === undefined
    ) {
      return {
        status: false,
        msg: "Please enter Name",
        field: "name",
      };
    } else if (specialChar.test(userData.name)) {
      return {
        status: false,
        msg: "Please enter valid Name",
        field: "name",
      };
    } else if (!SPACECHECK.test(userData.name)) {
      return {
        status: false,
        msg: "enter valid name",
        field: "name",
      };
    }
    if (
      userData.email === "" ||
      userData.email === null ||
      userData.email === undefined
    ) {
      return {
        status: false,
        msg: "Please enter Email Id",
        field: "email",
      };
    } else if (!emailFormat.test(userData.email)) {
      return {
        status: false,
        msg: "Please enter correct Email Id",
        field: "email",
      };
    }
    if (userData.email.length > 100) {
      return {
        status: false,
        msg: "Please enter correct Email Id",
        field: "email",
      };
    }
    if (
      userData.mobileNumber === "" ||
      userData.mobileNumber === null ||
      userData.mobileNumber === undefined
    ) {
      return {
        status: false,
        msg: "Please enter Mobile Number",
        field: "mobileNumber",
      };
    } else if (userData.mobileNumber.toString().length !== 10) {
      return {
        status: false,
        msg: "Please enter 10 digit Mobile Number",
        field: "mobileNumber",
      };
    }
    // if (userData.aadhaarNo === '' || userData.aadhaarNo === null || userData.aadhaarNo === undefined) {
    //     return {
    //         status: false,
    //         msg: 'Please enter Aadhar Number',
    //         field: 'aadhaarNo'
    //     }
    // }
    if (userData.aadhaarNo && userData.aadhaarNo.toString().length !== 12) {
      return {
        status: false,
        msg: "Please enter 12 digit Aadhaar Number",
        field: "aadhaarNo",
      };
    }
    if (userData.aadhaarNo === "000000000000") {
      return {
        status: false,
        msg: "enter valid Aadhaar Number",
        field: "aadhaarNo",
      };
    }
    // if (userData.panNumber === '' || userData.panNumber === null || userData.panNumber === undefined) {
    //     return {
    //         status: false,
    //         msg: 'Please enter PAN Number',
    //         field: 'panNumber'
    //     }
    // else}
    if (userData.panNumber && !panFormat.test(userData.panNumber)) {
      return {
        status: false,
        msg: "Please enter valid PAN Number",
        field: "panNumber",
      };
    }
    if (userData.firmName) {
      if (!SPACECHECK.test(userData.firmName)) {
        return {
          status: false,
          msg: "Please enter valid name",
          field: "firmName",
        };
      }
    }
    if (userData.firmGstNumber !== "") {
      if (!gstFormat.test(userData.firmGstNumber)) {
        return {
          status: false,
          msg: "Please enter valid GST Number",
          field: "firmGstNumber",
        };
      }
    }
    if (
      userData.password === "" ||
      userData.password === null ||
      userData.password === undefined
    ) {
      return {
        status: false,
        msg: "Please enter password ",
        field: "password",
      };
    } else if (userData.password.toString().length < 8) {
      return {
        status: false,
        msg: "Password should have minimum 8 characters! ",
        field: "password",
      };
    }
  
    return {
      status: true,
      msg: "",
      field: "",
    };
  };


  export {
    approveCustomValidation, CommunityLeadsPersonalValidation,
     CommunityLeadsBusinessValidation, AddressValidation, CommunityLeadLoanValidation,
     CommunityLeadsSalariedValidation, CommunityPersonalValidation, CommunityPersonalValidationNew
  }